module.exports = __webpack_public_path__ + "img/jtb-logo.a232cbae.png";